/* istanbul ignore file */
import { css } from 'styled-components';
export var iconDisabled = /*#__PURE__*/css(["filter:opacity(50%);"]);